// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"93d3677d","106":"551459c5","116":"9cfc3acb","175":"17a576b8","213":"28b5fcf7","256":"77543081","343":"05b8bc66","388":"a6c39763","396":"f741cdbc","455":"77450328","464":"c02e9249","538":"b33f9b3e","614":"4b6bf316","907":"23bfe488"}[chunkId] + ".chunk.js";
};